// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2vXd4","productName":"Table_productName__2IHPW"};